import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from "../../hooks/useAuth";
import {ADMIN_ROLE, STUDENT_ROLE, ADMIN_SCHOOL, ADMIN_CLASS} from "../../constants/roleconstants";

const AuthGuard: React.FC = () => {
    const navigate = useNavigate();
    const {auth} = useAuth();
    const { role } = auth;

    useEffect(() => {
        if (auth?.role === ADMIN_ROLE || auth?.role === ADMIN_SCHOOL) {
            navigate('/admin');
        } else if (auth?.role === STUDENT_ROLE) {
            navigate('/student/dashboard');
        } else if (auth?.role === ADMIN_CLASS) {
            navigate('/teacher');
        } else {
            navigate('/user/login');
        }
    }, [role]);

    return <div>Loading...</div>;
};

export default AuthGuard;
